import { Controller } from 'stimulus'

// Folded past 5 views, remembered per section, open on the page of one of its views.
const STORAGE_PREFIX = 'sidebar-views:'
const OPEN_CLASS     = 'sidebar__views--open'

export default class extends Controller {
  connect() {
    const { sidebarViewsActive, sidebarViewsDefault } = this.element.dataset
    if (sidebarViewsActive === 'true') return this._render(true)

    const stored = this._read()
    this._render(stored === null ? sidebarViewsDefault === 'true' : stored === 'open')
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const open = !this.element.classList.contains(OPEN_CLASS)
    this._render(open)
    this._write(open ? 'open' : 'closed')
  }

  // Private methods

  _render(open) {
    this.element.classList.toggle(OPEN_CLASS, open)
    const toggle = this.element.querySelector('.sidebar__views__toggle')
    if (toggle) toggle.setAttribute('aria-expanded', open)
  }

  _key() {
    return STORAGE_PREFIX + this.element.dataset.sidebarViewsKey
  }

  _read() {
    try { return window.localStorage.getItem(this._key()) } catch (_error) { return null }
  }

  _write(value) {
    try { window.localStorage.setItem(this._key(), value) } catch (_error) { /* private mode */ }
  }
}
